export default "__VITE_ASSET__be9aac5a__"